import React from 'react'
import "./Button.css"




const Button = ({ children }) => {
    return (
        <div className='rainbowButtWrap'>
            <button className='rainbowButt'>{children}</button>
            <div className='rainbowBG'>
            </div>
        </div>
    )
}

export default Button